import React, { Component, isValidElement, Fragment } from 'react';
import Table from '@/components/EditableTable';
import { Select, Tooltip } from 'antd';
import { QuestionCircleOutlined, EyeOutlined, ExclamationCircleOutlined } from '@ant-design/icons';
import { getEdgesColumns, timeUnitList, getTitle, timeValueList, timeArrayList, specTableColumns, getSpecPinInfo, SPEC, V_HIGH_ACTUAL, V_LOW_ACTUAL, getTimeMinMaxAndSpec, TIME_RISING, TIME_FALLING, getArrayValueByKey, LOW_TIME, HIGH_TIME, VALID_TIME, HOLD_TIME, SETUP_TIME, OVER_SHOOT, UNDER_SHOOT, DOUBLE_EDGE } from '../../../../services/Sierra/helper/WaveformResultHelper';
import { FALLING, RISING, HIGH, LOW, HOLD, SETUP, VHIGH, VLOW, VINH, VINL, OVERSHOOT, UNDERSHOOT, VALID } from '../../../../services/Result/Public/waveform/Mark/markConstant';
import { isMac } from '../../../../services/api/userAgent';
import { unitChange } from '../../../../services/helper/mathHelper';
import sierraLibrary from '../../../../services/Sierra/library/libraryStorage';
import { GPIO_SPEC } from '../../../../constants/libraryConstants';
import { getGPIOSpecLibrary } from '../../../../services/Sierra/library';
import { updateProcessingSpec } from '../../../../services/Sierra/results';
import { getClockHz, getClockItemValue, getGPIOSpecOptions, getSpecVoltage, getTimeDisplay } from '../../../../services/Sierra/helper/measurementHelper';
import { getTextWidth } from '../../../../services/helper/getTextWidth';
import { I2C } from '../../../../services/PCBHelper/constants';
import "./new.css";

const timeList = ['u', 'n', 'p'];
const WarningIcon = (info) => {
  return <Tooltip title={info} placement='top'>
    <ExclamationCircleOutlined />
  </Tooltip>
};
class PostProcessEdgesContent extends Component {
  constructor() {
    super();
    this.state = {
      risingEdgeTableData: [],
      fallingEdgeTableData: [],
      title: '',
      tableData: [],
      minmaxDataTableData: [],
      timeUnit: '',
      columns: [],
      selected: [],
      keyCode: null,
      specTableData: [],
      showLines: [],
      gpioSpecList: sierraLibrary.getTree(GPIO_SPEC) || []
    }
    this.ctrlKey = isMac() ? 91 : 17;
    this.shiftKey = 16;
    this.dialogRoot = document.getElementById('root');
  }

  componentDidMount = () => {
    const { currentPostProcessData, onClearSelected, postProcessConfig } = this.props;
    if (currentPostProcessData) {
      this.getPanelData(currentPostProcessData, postProcessConfig)
    }
    if (onClearSelected) {
      onClearSelected(this.clearSelected);
    }
    document.addEventListener('keydown', this.KeyDown, true);
    document.addEventListener('keyup', this.KeyUp, true);
  }

  componentDidUpdate = (prevProps) => {
    const { specTableData } = this.state;
    const { currentPostProcessData, postProcessConfig, libraryTreeInfo } = this.props;
    if (currentPostProcessData && currentPostProcessData.title && (!prevProps.currentPostProcessData || prevProps.currentPostProcessData.title !== currentPostProcessData.title)) {
      this.getPanelData(currentPostProcessData, postProcessConfig);
    }
    if (libraryTreeInfo && libraryTreeInfo.includes(GPIO_SPEC)) {
      this.setState({
        gpioSpecList: sierraLibrary.getTree(GPIO_SPEC) || []
      })
      const specInfo = specTableData[0];
      if (specInfo && specInfo.id) {
        this.selectSpec(null, specInfo.id);
      }

      this.props._updateLibraryTree && this.props._updateLibraryTree(null);
    }
  }

  componentWillUnmount() {
    document.removeEventListener('keydown', this.KeyDown, true);
    document.removeEventListener('keyup', this.KeyUp, true);
  }

  KeyDown = (e) => {
    if ([this.ctrlKey, this.shiftKey].includes(e.keyCode)) {
      this.setState({
        keyCode: e.keyCode
      })
    }
  }

  KeyUp = (e) => {
    this.setState({
      keyCode: null,
    });
  }

  clearSelected = () => {
    this.selectHandle()
    /* this.setState({
      selected: []
    }, () => {
      if (this.props.setResultOpera) {
        this.props.setResultOpera({ selected: [] })
      }
    }) */
  }

  // dataIndex: string / arrary
  changeShowLines = (dataIndex) => {
    const { showLines, specTableData } = this.state;
    if (!specTableData[0]) return;
    let newShowLines = [];
    if (Array.isArray(dataIndex)) {
      newShowLines = dataIndex;
    } else {
      newShowLines = showLines.includes(dataIndex) ? showLines.filter(it => it !== dataIndex) : [...showLines, dataIndex];
    }
    const horizontalLine = [], horizontalLineSetting = [];
    for (const item of newShowLines) {
      const { vdd, vHigh, vLow } = specTableData[0];
      const value = specTableData[0][item];
      const { min, max } = getSpecVoltage(vdd, item === V_HIGH_ACTUAL ? vHigh : vLow);
      const color = !min && !max ? "#005881" : (!min || value >= min) && (!max || value <= max) ? "green" : "red";
      horizontalLine.push(value);
      const text = item === V_HIGH_ACTUAL ? `Actual V-High ${value}V` : `Actual V-Low ${value}V`;
      const textWidth = getTextWidth(text, 12, null, 500);
      horizontalLineSetting.push({ color, text, textXMove: -textWidth, textYMove: -10 });
    }
    this.setState({ showLines: newShowLines }, () => {
      this.props.setTargetLinesValue({ horizontalLine: newShowLines.map(it => specTableData[0][it]), drawType: 'horizontalLine', horizontalLineSetting })
    })
  }

  getPanelData = async (currentPostProcessData, postProcessConfig) => {
    const { edgesInfo, title, displayTitle, timeUnit, isCLK } = currentPostProcessData;
    let tableData = [], _minmaxDataTableData = []
    const { interfaceTag, sweep, isSweepNewPPROC, isNewPPROC, clock } = this.props;
    const specInfo = getSpecPinInfo(postProcessConfig, edgesInfo) || {};
    if (edgesInfo && edgesInfo.edges && edgesInfo.edges.length) {
      for (const info of edgesInfo.edges) {
        tableData.push(info)
      }
      const { minInfo = {}, maxInfo = {} } = edgesInfo
      _minmaxDataTableData = [{ index: "Min", ...minInfo || {} }, { index: "Max", ...maxInfo || {} }]
    }

    const _timeUnit = timeUnit ? timeUnit : this.state.timeUnit;
    const doubleEdgeExist = tableData.find(item => item.doubleEdgeFalling && item.doubleEdgeFalling.length);
    const doubleEdgeMinMaxExist = _minmaxDataTableData.find(item => !!item.doubleEdgeFalling);
    const isShowSHTime = interfaceTag === I2C && ((sweep && isSweepNewPPROC) || isNewPPROC);
    let newColumns = getEdgesColumns({ isCLK, doubleEdgeExist: doubleEdgeExist || doubleEdgeMinMaxExist, interfaceTag, isShowSHTime });
    const newSpecColumns = specTableColumns.map((item) => {
      if (item.dataIndex === SPEC) {
        return {
          ...item,
          onCell: (record) => {
            const { gpioSpecList } = this.state;
            const { interfaceTag } = this.props;
            const options = getGPIOSpecOptions(gpioSpecList, interfaceTag);
            return {
              record,
              edit: 'select',
              dataIndex: "name",
              optGroup: true,
              notIncludesGroup: true,
              handleSave: ({ name }) => this.selectSpec(name),
              handleClear: () => this.selectSpec(null, null, true),
              allowEmpty: true,
              allowClear: true,
              options,
              getPopupContainer: document.getElementById('root')
            }
          },
          render: (_, record) => {
            let voltageSpecNotExist = "", timeSpecNotExist = "", warningMsg = "";
            if (record.spec && record.id && (!record.spec.vHigh || !record.spec.vHigh.length) && (!record.spec.vLow || !record.spec.vLow.length)) {
              voltageSpecNotExist = `vdd: ${record.vdd}V`;
            }
            const { interfaceTag } = this.props;
            if (record.spec && record.id
              && (!record.spec.rising || !record.spec.rising.length)
              && (!record.spec.falling || !record.spec.falling.length)
              && (!record.spec.setup || !record.spec.setup.length)
              && (!record.spec.hold || !record.spec.hold.length)
              && (interfaceTag === I2C && (!record.spec.valid || !record.spec.valid.length))
            ) {
              const findTiming = postProcessConfig.timing.find(it => it.clock_pin === record.id || (it.signal_pins || []).includes(record.id));
              const _clock = findTiming && findTiming.datarate ? findTiming.datarate : `${clock}Hz`;
              timeSpecNotExist = `clock: ${_clock}`;
            }

            if (voltageSpecNotExist || timeSpecNotExist) {
              const title = voltageSpecNotExist && timeSpecNotExist ? `${voltageSpecNotExist} and ${timeSpecNotExist} do` : (voltageSpecNotExist ? `${voltageSpecNotExist} does` : `${timeSpecNotExist} does`)
              warningMsg = `The data ${title} not exist in the spec file.`
            }

            const { gpioSpecList } = this.state;
            const exist = !record.id || gpioSpecList.find(it => it.id === record.id);
            return exist
              ? <Fragment>
                <span className='measurement-setup-spec-title'>{record.name}</span>
                <span className='measurement-setup-spec-title-warning-icon'>{warningMsg ? WarningIcon(warningMsg) : null}</span>
              </Fragment>
              : <span>
                {record.name}
                <Tooltip
                  title={`${record.name} has been deleted, the file is invalid.`}
                  classNames={{ root: 'aurora-tooltip' }}
                >
                  <QuestionCircleOutlined className='aurora-file-check-icon' />
                </Tooltip>
              </span>
          }
        }
      } else if ([V_HIGH_ACTUAL, V_LOW_ACTUAL].includes(item.dataIndex)) {
        return {
          ...item,
          title: () => {
            const { showLines, specTableData } = this.state;
            const value = (specTableData[0] || {})[item.dataIndex];
            return <span>
              <span className='eye-icon-title'>{item.title}</span>
              {
                (value !== "" && !isNaN(value)) ? <Tooltip title={`Display ${item.dataIndex === V_HIGH_ACTUAL ? 'actual V-High' : 'actual V-Low'} line.`} classNames={{ root: 'aurora-tooltip' }}>
                  <EyeOutlined
                    style={{ color: showLines.includes(item.dataIndex) ? '#1890ff' : undefined }}
                    onClick={() => this.changeShowLines(item.dataIndex)} />
                </Tooltip> : <Tooltip title={`${item.dataIndex === V_HIGH_ACTUAL ? 'Actual V-High' : 'Actual V-Low'} are not calculated, please recalculate in the measurement (in the top right corner).`} classNames={{ root: 'aurora-tooltip' }}>
                  <ExclamationCircleOutlined style={{ color: '#f5aa16' }} />
                </Tooltip>
              }
            </span>
          },
          render: (value, record) => {
            const { vdd, vHigh, vLow } = record;
            const { min, max } = getSpecVoltage(vdd, item.dataIndex === V_HIGH_ACTUAL ? vHigh : vLow);

            const className = !min && !max ? "" : (!min || value >= min) && (!max || value <= max) ? "data-pass" : "data-warning";
            return <span className={className}>{value !== "" && !isNaN(value) ? `${value}V` : ""}</span>
          }
        }
      }

      return item
    })

    newColumns = this.initColumns({ newColumns, specInfo, interfaceTag, _timeUnit });

    const oldTimeUnit = this.state.timeUnit;

    tableData.forEach((item, index) => { item.index = index + 1; });
    this.setState({
      title,
      displayTitle,
      tableData: JSON.parse(JSON.stringify(tableData)),
      timeUnit: _timeUnit,
      minmaxDataTableData: JSON.parse(JSON.stringify(_minmaxDataTableData)),
      columns: newColumns,
      // minMaxColumns,
      selected: [],
      specTableData: [specInfo],
      specColumns: newSpecColumns
    }, () => {
      if (oldTimeUnit && timeList.includes(oldTimeUnit) && oldTimeUnit !== this.state.timeUnit) {
        this.timeChange(oldTimeUnit)
      }
      this.setResultSelected()
      this.changeShowLines([V_HIGH_ACTUAL, V_LOW_ACTUAL])
      this.selectSpec(null, specInfo.id);
    })
  }

  selectSpec = async (name, id, isClear) => {
    const { postProcessConfig, verificationId, currentPostProcessData: { edgesInfo = {}, curveName, verificationId: _verificationId }, currentPostProcessData: { isCLK }, sweep, clock } = this.props;

    const pcbIndex = (postProcessConfig.pcbs || []).findIndex(it => it.name === edgesInfo.pcb);
    const vId = sweep ? _verificationId : verificationId;
    if (pcbIndex < 0) {
      return;
    }
    // get spec file info
    const gpioSpecList = sierraLibrary.getTree(GPIO_SPEC);
    const specId = isClear ? null : (gpioSpecList.find(it => it.name === name || it.id === id) || {}).id;
    if (!specId && !isClear) {
      return;
    }
    const specInfo = specId ? await getGPIOSpecLibrary(specId) || {} : {};
    const { vdds = [], clocks = [] } = specInfo.config || {};
    // update pcbs -> components -> pins -> spec
    for (let pcbInfo of postProcessConfig.pcbs) {

      (pcbInfo.components || []).forEach(comp => {
        comp.pins.forEach(t => {
          const { vdd } = t;
          const vddConfig = vdds.find(it => it.vdd === String(vdd));
          const findTiming = postProcessConfig.timing.find(it => it.clock_pin === t.id || (it.signal_pins || []).includes(t.id));
          const _clock = findTiming && findTiming.datarate ? findTiming.datarate.replace("Hz", "") || clock : clock;
          const clockConfig = clocks.find(it => getClockHz(it.clock) === getClockHz(_clock));
          const { vHigh = {}, vLow = {} } = vddConfig || {};
          const { rising = {}, falling = {}, setup = {}, hold = {}, valid = {} } = clockConfig || {};
          t.spec = {
            id: specInfo.id || "",
            name: specInfo.name || "",
            vHigh: vddConfig ? [vHigh.min || "", vHigh.max || ""] : [],
            vLow: vddConfig ? [vLow.min || "", vLow.max || ""] : [],
            rising: clockConfig ? [rising.min || "", rising.max || ""] : [],
            falling: clockConfig ? [falling.min || "", falling.max || ""] : [],
            setup: clockConfig ? [setup.min || "", setup.max || ""] : [],
            hold: clockConfig ? [hold.min || "", hold.max || ""] : [],
            valid: clockConfig ? [valid.min || "", valid.max || ""] : [],
          }
        })
      });
    }
    const _postProcessConfig = { ...postProcessConfig };
    try {
      if (vId) {
        await updateProcessingSpec(vId, _postProcessConfig);
      }
    } catch (error) {
      console.error(error)
    }
    const sweepName = (curveName || "").split("@")[0];
    this.props.updateGPIOSpec(sweepName, _postProcessConfig);
    // update spec tableInfo
    const newSpecInfo = getSpecPinInfo(_postProcessConfig, edgesInfo);
    // update 
    const { timeUnit, showLines } = this.state;
    const { interfaceTag, isSweepNewPPROC, isNewPPROC } = this.props;
    const isShowSHTime = interfaceTag === I2C && ((sweep && isSweepNewPPROC) || isNewPPROC);
    const { tableData, minmaxDataTableData } = this.state;
    const doubleEdgeExist = tableData.find(item => item.doubleEdgeFalling && item.doubleEdgeFalling.length);
    const doubleEdgeMinMaxExist = minmaxDataTableData.find(item => !!item.doubleEdgeFalling);
    let newColumns = getEdgesColumns({ isCLK, doubleEdgeExist: doubleEdgeExist || doubleEdgeMinMaxExist, interfaceTag, isShowSHTime });
    newColumns = this.initColumns({ newColumns, specInfo: newSpecInfo, interfaceTag, _timeUnit: timeUnit })
    this.setState({ specTableData: [newSpecInfo], columns: newColumns }, () => {
      this.changeShowLines(showLines);
    });
  }

  initColumns = ({ newColumns, specInfo, interfaceTag, _timeUnit }) => {
    newColumns.forEach((item) => {
      if (timeUnitList.includes(item.dataIndex)) {
        const title = getTitle(item.dataIndex, interfaceTag)
        item.title = `${title} (${_timeUnit}s)`
      }
      if ([TIME_RISING, DOUBLE_EDGE, TIME_FALLING].includes(item.dataIndex)) {
        item.render = (value, record) => {
          const { timeUnit } = this.state;
          const { minValue: minRising, maxValue: maxRising } = getClockItemValue(specInfo.rising || [], false, timeUnit + "s");
          const { minValue: minFalling, maxValue: maxFalling } = getClockItemValue(specInfo.falling || [], false, timeUnit + "s");
          const isShowRisingSpec = specInfo.rising && specInfo.rising.length;
          const isShowFallingSpec = specInfo.falling && specInfo.falling.length;
          if (value && value.length > 1) {
            const trueValue = getArrayValueByKey(item.dataIndex) || null;
            const fixNum = item.dataIndex === DOUBLE_EDGE ? 4 : 2;
            const _trueValue = record[trueValue] !== "" && !isNaN(Number(record[trueValue])) ? Number(record[trueValue]).toFixed(fixNum) : "";
            const minValue = value[0] !== "" && !isNaN(value[0]) ? Number(value[0]).toFixed(fixNum) : "",
              maxValue = value[1] !== "" && !isNaN(value[1]) ? Number(value[1]).toFixed(fixNum) : "";
            let className;
            if (
              (item.dataIndex === TIME_RISING
                && ((maxRising && _trueValue > maxRising) || (minRising && _trueValue < minRising)))
              ||
              (item.dataIndex === TIME_FALLING
                && ((maxFalling && _trueValue > maxFalling) || (minFalling && _trueValue < minFalling)))
            ) {
              className = "data-warning";
            }
            return <span className={className}>{_trueValue}[{minValue}, {maxValue}]</span>;
          }

          if (["Min", "Max"].includes(record.index)) {
            const fixNum = item.dataIndex === DOUBLE_EDGE ? 4 : 2;
            if (!value) {
              return <div>-</div>;
            }
            const trueValue = value !== "" && !isNaN(value) ? Number(value).toFixed(fixNum) : "";
            const { min, max, isShowSpec } = getTimeMinMaxAndSpec({
              dataIndex: item.dataIndex,
              isShowRisingSpec,
              isShowFallingSpec,
              minRising,
              maxRising,
              minFalling,
              maxFalling
            })

            let className = "data-pass";
            if ([TIME_RISING, TIME_FALLING].includes(item.dataIndex) && value !== "" && !isNaN(trueValue) && (((max || max === 0) && trueValue > max) || ((min || min === 0) && trueValue < min))) {
              className = "data-warning";
            }

            return <span>
              {isShowSpec
                ? <Fragment>
                  <span className={className}>{trueValue}</span>
                  <span> | <span className="data-spec">[{getTimeDisplay(min, timeUnit, fixNum)}, {getTimeDisplay(max, timeUnit, fixNum)}]</span></span>
                </Fragment>
                : <span>{trueValue || "-"}</span>}
            </span>;
          }
        }
      } else if ([SETUP_TIME, HOLD_TIME, VALID_TIME, HIGH_TIME, LOW_TIME].includes(item.dataIndex)) {
        item.render = (value, record) => {
          const { timeUnit } = this.state;
          const { minValue: minSetup, maxValue: maxSetup } = getClockItemValue(specInfo.setup || [], false, timeUnit + "s");
          const { minValue: minHold, maxValue: maxHold } = getClockItemValue(specInfo.hold || [], false, timeUnit + "s");
          const { minValue: minValid, maxValue: maxValid } = getClockItemValue(specInfo.valid || [], false, timeUnit + "s");
          const isShowSetupSpec = interfaceTag === I2C && specInfo.setup && specInfo.setup.length;
          const isShowHoldSpec = interfaceTag === I2C && specInfo.hold && specInfo.hold.length;
          const isShowValidSpec = interfaceTag === I2C && specInfo.valid && specInfo.valid.length;
          const { min, max, isShowSpec } = getTimeMinMaxAndSpec({
            dataIndex: item.dataIndex,
            isShowSetupSpec,
            isShowHoldSpec,
            isShowValidSpec,
            minSetup,
            maxSetup,
            minHold,
            maxHold,
            minValid,
            maxValid,
          })
          const trueValue = value !== "" && !isNaN(value) ? Number(value).toFixed(2) : "";
          let className = "data-pass";
          if ([SETUP_TIME, HOLD_TIME, VALID_TIME].includes(item.dataIndex) && (value !== "" && !isNaN(trueValue)) && (((max || max === 0) && trueValue > max) || ((min || min === 0) && trueValue < min))) {
            className = "data-warning";
          }

          if (["Min", "Max"].includes(record.index)) {
            return <span>
              {isShowSpec
                ? <Fragment>
                  <span className={className}>{trueValue}</span>
                  <span> | <span className="data-spec">[{getTimeDisplay(min, timeUnit, 2)}, {getTimeDisplay(max, timeUnit, 2)}]</span></span>
                </Fragment>
                : <span>{trueValue || "-"}</span>}
            </span>;
          }

          const _className = className === "data-pass" ? "" : className;

          return <span className={_className}>{trueValue || "-"}</span>
        }
      } else if ([OVER_SHOOT, UNDER_SHOOT].includes(item.dataIndex)) {
        item.render = (value) => {
          if (value) {
            if (value > 1) {
              return value !== "" && !isNaN(value) ? Number(value).toFixed(2) : value || ""
            }
            const _value = value.toPrecision ? value.toPrecision(2) : value || ""
            return _value < 0.1 ? Number(_value).toExponential() : _value
          }
          return <div>-</div>
        }
      } else {
        item.render = (value) => {
          if (value) {
            return value;
          }
          return <div>-</div>
        }
      }
    })
    return newColumns;
  }

  getValue = (number, isList, value, value2) => {
    if (!isList && !value) { return "" };
    if (isList && (!value || !value2)) { return [] }
    const _value = value / number;
    if (!isList) {
      return _value;
    }
    const _value2 = value2 / number;
    return [_value, _value2]
  }

  dataSelect = (record, index) => {
    if (["Min", "Max"].includes(record.index)) return;
    const { selected: prevSelected, keyCode } = this.state

    let _selected = [...prevSelected];
    if (keyCode === this.ctrlKey) {
      _selected = [index]
    } else if (keyCode === this.shiftKey) {
      _selected = _selected.includes(index) ? _selected.filter(item => item !== index) : [..._selected, index]
    } else {
      const mirrorIndex = record.is_rising ? index + 1 : index - 1;
      _selected = prevSelected.includes(index) ? [] : [index, mirrorIndex];
    }
    this.setState({
      selected: _selected
    }, () => {
      if (this.props.setResultOpera) {
        this.props.setResultOpera({ selected: _selected })
      }
      this.selectHandle()
    })
  }

  setResultSelected = () => {
    const { resultOpera = {} } = this.props;
    const { selected = [] } = resultOpera;
    this.setState({
      selected
    }, () => {
      this.selectHandle()
    })
  }

  selectHandle = () => {
    let risingList = [], fallingList = [], anotherTimeList = [], measureList = [], shootList = [];
    const { selected, tableData, timeUnit } = this.state;
    const { currentPostProcessData, interfaceTag, compInfo, sweep, isSweepNewPPROC, isNewPPROC } = this.props;
    const { isCLK, clkPinWaveformSignal } = currentPostProcessData;
    if (!currentPostProcessData.curveName) {
      return;
    }

    if (!selected.length) {
      this.props.clickPostProcessData({ timeList: [...fallingList, ...risingList], ...currentPostProcessData, timeUnit, rangeList: [...risingList, ...fallingList], display: false, clkPinWaveformSignal })
      return;
    }

    const isShowSHTime = interfaceTag === I2C && ((sweep && isSweepNewPPROC) || isNewPPROC);
    const edgesInfo = currentPostProcessData.edgesInfo;
    let /* clkPostProcessData = {}, */ clkCompData = {}, clkCurveName = null;
    if (sweep) {
      const currCompInfo = compInfo.find(item => item.portSelectId === currentPostProcessData.curveName) || {};
      const curveNames = (currCompInfo.curveName || "").split("_");
      const id = curveNames[curveNames.length - 1];
      clkCurveName = `${clkPinWaveformSignal}_${id}`;
      clkCompData = clkPinWaveformSignal ? compInfo.find(item => item.curveName === clkCurveName) || {} : {};
      /* 
            clkPostProcessData = clkCompData.postProcessData || {}; */
    } else {
      clkCompData = clkPinWaveformSignal ? compInfo.find(item => item.curveName === clkPinWaveformSignal) || {} : {};
      /*  clkPostProcessData = clkCompData.postProcessData || {}; */
      clkCurveName = clkPinWaveformSignal;
    }

    //const clkEdges = clkPostProcessData.edgesInfo ? JSON.parse(JSON.stringify(clkPostProcessData.edgesInfo.edges || [])) : [];
    const clkSignal = clkCompData.signal;
    const sweepPortSelectId = clkCompData.portSelectId;
    if (edgesInfo) {
      const VList = [VHIGH, VLOW, VINH, VINL];
      for (let key of VList) {
        const value = edgesInfo[key];
        if (!value && value !== 0) {
          continue;
        }
        const findIndex = measureList.findIndex(item => item.value === value);
        if (findIndex > -1) {
          if (measureList[findIndex].extra.sameType) {
            measureList[findIndex].extra.sameType.push(key)
          } else {
            measureList[findIndex].extra.sameType = [key]
          }
          continue
        }
        measureList.push({ value, type: key, extra: { sameType: [] } })
      }
    }

    for (let _index of selected) {
      const data = tableData[_index];

      if (!tableData[_index]) {
        continue
      }

      let overShootTime = [], underShootTime = [];
      const timeType = data.timeRising && data.timeRising.length ? RISING : FALLING
      if (data.timeRising && data.timeRising.length) {
        risingList = data.timeRising.map(item => { return { value: item, type: RISING } })
        data.timeRising[1] && overShootTime.push(data.timeRising[1])
        data.timeRising[0] && underShootTime.push(data.timeRising[0])
        if (isCLK) {
          data.high_time && anotherTimeList.push({ value: data.timeRising[1] + data.high_time, another: data.timeRising[1], type: HIGH })
          data.high_time && overShootTime.push(data.timeRising[1] + data.high_time)
        } else if (isShowSHTime) {
          /*   data.hold_time && anotherTimeList.push({ value: data.timeRising[0] - data.hold_time, another: data.timeRising[0], type: HOLD })
            data.setup_time && anotherTimeList.push({ value: data.timeRising[1] + data.setup_time, another: data.timeRising[1], type: SETUP })
            data.setup_time && overShootTime.push(data.timeRising[1] + data.setup_time) */

          data.hold_time && anotherTimeList.push({
            value: data.timeRising[0] - data.hold_time,
            another: data.timeRising[0],
            type: HOLD,
            clkCurveName
          })
          data.valid_time && anotherTimeList.push({
            value: data.timeRising[1] - data.valid_time,
            another: data.timeRising[1],
            type: VALID,
            clkCurveName
          })
          data.setup_time && anotherTimeList.push({
            value: data.timeRising[1] + data.setup_time,
            another: data.timeRising[1],
            type: SETUP,
            clkCurveName
          })
          data.setup_time && overShootTime.push(data.timeRising[1] + data.setup_time)
        }
      }
      if (data.timeFalling && data.timeFalling.length) {
        fallingList = data.timeFalling.map(item => { return { value: item, type: FALLING } })
        data.timeFalling[0] && overShootTime.push(data.timeFalling[0])
        data.timeFalling[1] && underShootTime.push(data.timeFalling[1])
        if (isCLK) {
          data.low_time && anotherTimeList.push({ value: data.timeFalling[1] + data.low_time, another: data.timeFalling[1], type: LOW })
        } else if (isShowSHTime) {
          /*  data.hold_time && anotherTimeList.push({ value: data.timeFalling[0] - data.hold_time, another: data.timeFalling[0], type: HOLD })
           data.setup_time && anotherTimeList.push({ value: data.timeFalling[1] + data.setup_time, another: data.timeFalling[1], type: SETUP }) */
          data.hold_time && anotherTimeList.push({
            value: data.timeFalling[0] - data.hold_time,
            another: data.timeFalling[0],
            type: HOLD,
            clkCurveName

          })
          data.valid_time && anotherTimeList.push({
            value: data.timeFalling[1] - data.valid_time,
            another: data.timeFalling[1],
            type: VALID,
            clkCurveName

          })
          data.setup_time && anotherTimeList.push({
            value: data.timeFalling[1] + data.setup_time,
            another: data.timeFalling[1],
            type: SETUP,
            clkCurveName
          })
        }
      }

      if (data[OVERSHOOT]) {
        let _value = data[OVERSHOOT];
        if (_value > 1) {
          _value = _value.toFixed(2)
        } else {
          _value = _value.toPrecision(2)
        }
        if (!shootList.find(item => item.value === _value && item.type === OVERSHOOT)) {
          _value = Number(_value)
          overShootTime.length && shootList.push({ value: _value + edgesInfo[VHIGH], type: OVERSHOOT, another: edgesInfo ? edgesInfo[VHIGH] : _value, shootTime: overShootTime, extra: { timeType } })
        }
      }
      if (data[UNDERSHOOT]) {
        let _value = data[UNDERSHOOT];
        if (_value > 1) {
          _value = _value.toFixed(2)
        } else {
          _value = _value.toPrecision(2)
        }
        if (!shootList.find(item => item.value === _value && item.type === UNDERSHOOT)) {
          _value = Number(_value)
          underShootTime.length && shootList.push({ value: edgesInfo[VLOW] - _value, type: UNDERSHOOT, another: edgesInfo ? edgesInfo[VLOW] : _value, shootTime: underShootTime, extra: { timeType } })
        }
      }
    }
    this.props.clickPostProcessData({ timeList: [...fallingList, ...risingList, ...anotherTimeList], shootList, measureList, ...currentPostProcessData, timeUnit, rangeList: [...risingList, ...fallingList, ...anotherTimeList], display: true, clkCurveName, clkSignal, sweepPortSelectId });
  }

  getYScroll = () => {
    const contentRoot = document.getElementById('waveFrom-post-process-content-id') || {}
    if (contentRoot) {
      const height = contentRoot.clientHeight;
      return !isNaN(height) ? height - 160 : 200
    }
    return 200
  }

  timeChange = (value) => {
    const { timeUnit, tableData, minmaxDataTableData, columns } = this.state;
    const oldTimeUnit = `${timeUnit}s`;
    const newTimeUnit = `${value}s`;
    let newColumns = [...columns];
    newColumns.forEach((item) => {
      if (timeUnitList.includes(item.dataIndex)) {
        const title = getTitle(item.dataIndex)
        item.title = `${title} (${newTimeUnit})`
      }
    })

    let newTableData = [...tableData];
    newTableData.forEach(item => {
      timeValueList.forEach(key => {
        if (item[key]) {
          item[key] = unitChange({ num: item[key], oldUnit: oldTimeUnit, newUnit: newTimeUnit }).number
        }
      })
      timeArrayList.forEach(key => {
        if (item[key] && Array.isArray(item[key])) {
          item[key].forEach((v, index) => {
            item[key][index] = unitChange({ num: v, oldUnit: oldTimeUnit, newUnit: newTimeUnit }).number
          })
        }
      })
    })

    let newMinMaxData = [...minmaxDataTableData];
    newMinMaxData.forEach(item => {
      timeUnitList.forEach(key => {
        if (item[key]) {
          item[key] = unitChange({ num: item[key], oldUnit: oldTimeUnit, newUnit: newTimeUnit }).number;

        }
      })
    })

    this.setState({
      timeUnit: value,
      columns: newColumns,
      tableData: newTableData,
      minmaxDataTableData: newMinMaxData
    })
  }

  render() {
    const { title, tableData, displayTitle, minmaxDataTableData, columns, selected, timeUnit, specTableData, specColumns } = this.state;
    const yScroll = this.getYScroll();
    return <div className='waveFrom-post-process-content' id="waveFrom-post-process-content-id">
      <div className='post-process-content-title'>
        {displayTitle && isValidElement(displayTitle) ? displayTitle : title}
        <span className='post-process-content-title-divide'>|</span>
        <span className='post-process-content-title-unit'>Time Unit:</span>
        <Select
          size="small"
          value={timeUnit}
          onChange={this.timeChange}
          options={timeList.map(t => ({ value: t, label: `${t}s` }))}
        />
      </div>
      <Table
        columns={columns}
        rowKey={(record) => `post-process-${record.index}`}
        dataSource={[...tableData, ...minmaxDataTableData]}
        bordered
        size="small"
        scroll={{ y: yScroll }}
        className="post-process-panel-data-table"
        onRow={(record, index) => {
          return {
            onClick: e => this.dataSelect(record, index),
          };
        }}
        rowClassName={(record, index) => {
          const classNames = [];
          if (selected.includes(index)) {
            classNames.push('post-process-panel-data-selected-row post-process-panel-data-row');
          } else {
            classNames.push('post-process-panel-data-row');
          }
          if (record.index === "Min") classNames.push('sticky-row-min');
          if (record.index === "Max") classNames.push('sticky-row-max');
          return classNames.join(' ');
        }}
      />
      <Table
        columns={specColumns}
        rowKey={(record) => `post-process-spec-${record.index}`}
        dataSource={specTableData} // {}
        bordered
        size="small"
        className="post-process-panel-data-table"
      />
      {/* Min,Max data is consolidated into a table */}
      {/* <Table
        columns={minMaxColumns}
        rowKey={(record) => record.index}
        dataSource={minmaxDataTableData}
        bordered
        size="small"
        className="post-process-panel-compare-table post-process-panel-edge-compare-table"
        showHeader={false}
      /> */}
    </div>
  }
}

export default PostProcessEdgesContent;